import { type FC } from "react";

import { UnstyledButton, VisuallyHidden } from "@mantine/core";
import { Tooltip } from "@snapchat/snap-design-system";
import { InformationIcon, Sizes } from "@snapchat/snap-design-system-icons";

import { type SubmissionQuota } from "../../models/SubmissionQuota";

import { type SubmissionQuotaContext } from "./SubmissionQuotaContext";
import styles from "./SubmissionQuotaInline.module.css";
import { SubmissionQuotaResetTooltipContent } from "./SubmissionQuotaResetTooltipContent";
import { AboutSubmissionLimits } from "./messages.generated";

export const SubmissionQuotaResetTooltip: FC<{ context: SubmissionQuotaContext; quota: SubmissionQuota }> = ({
    context,
    quota,
}) => (
    <Tooltip content={<SubmissionQuotaResetTooltipContent entries={[{ context, quota }]} />}>
        <UnstyledButton type="button" className={styles.infoButton}>
            <InformationIcon size={Sizes.Small} aria-hidden />
            <VisuallyHidden>
                <AboutSubmissionLimits />
            </VisuallyHidden>
        </UnstyledButton>
    </Tooltip>
);
